import { TemplatesExchangeIcon } from 'src/icons';
import { AppstoreOutlined } from '@ant-design/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { ProIcon } from 'src/icons/Pro.icon';
import { LockIcon } from 'src/icons/Lock.icon';
import { UpgradeTooltip } from '../ambient_solo/components/Payments/UpgradeTooltip';
import { useIsOP } from 'src/hooks/misc';

const TemplatesExchangeSideMenu = () => {
  const { isEntitled: templatesExchangeFeature } =
    useFeatureEntitlements('template-exchange');
  const { isEntitled: isAmbientEnabled } = useFeatureEntitlements('ambient');
  const isOP = useIsOP();

  if (isOP || !isAmbientEnabled) {
    return []; // Hiding Template Exchange for OP
  }

  const menus = templatesExchangeFeature
    ? [
        {
          path: '/templatesexchange',
          title: (
            <span className="flex items-center gap-2">
              Template Exchange
              <ProIcon />
            </span>
          ),
          icon: <TemplatesExchangeIcon />,
        },
      ]
    : [
        {
          path: '/templatesexchange',
          title: (
            <UpgradeTooltip>
              <span className="flex items-center gap-2">
                Template Exchange
                <LockIcon />
              </span>
            </UpgradeTooltip>
          ),
          icon: <AppstoreOutlined />,
        },
      ];
  return menus;
};

export default TemplatesExchangeSideMenu;
